import { MeasurementUnit } from '~/types/interfaces/measurementUnit';

export const groupMeasurementByCategory = (
  measurementUnits?: MeasurementUnit[],
) => {
  if (!measurementUnits) return;

  const groupedByCategory = measurementUnits.reduce<
    Record<string, MeasurementUnit[]>
  >((group, measurementUnit) => {
    const { category } = measurementUnit;
    group[category] = group[category] || [];
    group[category].push(measurementUnit);
    return group;
  }, {});

  return groupedByCategory;
};

export const mapGroupedMeasurementToOptions = (
  groupedMeasurementByCategory?: Record<string, MeasurementUnit[]>,
) => {
  if (!groupedMeasurementByCategory) return [];

  return Object.entries(groupedMeasurementByCategory).map(
    ([category, units]) => ({
      label: category,
      options: units.map((unit) => ({
        value: unit._id || '',
        label: unit.pluralLabel || unit.singularLabel || '',
      })),
    }),
  );
};
